import { useEffect, useRef, useState } from "react";
import "./Requestopra.css";
import { insertLog } from "../Logs/InsertLog";
import DatasetDS from "../../DataServices/DatasetDs";
import { useCustomContext } from "../CustomComponents/CustomComponents";
import RequestSentDetailsDS from "../../DataServices/RequestSentDetailsDS";
import { FaEye } from "react-icons/fa";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import RequestOpraDS from "../../DataServices/RequestOpraDS";
import { FaPlus, FaTrash } from "react-icons/fa";
import { LuAsterisk } from "react-icons/lu";
import { FiChevronDown, FiChevronsDown, FiSearch } from "react-icons/fi";
import { RiDeleteBin3Fill } from "react-icons/ri";
import { IoAdd } from "react-icons/io5";
import { PDFDocument, StandardFonts } from "pdf-lib";


const RequestOpra = () => {


    const datasetDS = new DatasetDS();
    const requestSentDS = new RequestSentDetailsDS();
    const requestOpraDS = new RequestOpraDS();

    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];
    const { showAlert, stopHudRotation, hud, showToast } = useCustomContext();

    const [datasetID, setDatasetID] = useState("");
    const [datasetName, setDatasetName] = useState("");
    const [agencies, setAgencies] = useState([]);
    const [datasets, setDatasets] = useState([]);
    const [agencyID, setAgencyID] = useState("");
    const [opraData, setOpraData] = useState(null);


    const [smtpSettings, setSmtpSettings] = useState({
        fromEmail: "",
        replyToEmail: "",
        subject: ""
    });

    const [requestEmails, setRequestEmails] = useState([]);
    const [responseEmails, setResponseEmails] = useState([]);

    const [triggerEvents, setTriggerEvents] = useState([
        { waitDays: "", action: "" }
    ]);

    const [offsetBegins, setOffsetBegins] = useState("");
    const [offsetEnds, setOffsetEnds] = useState("");

    const [acroFields, setAcroFields] = useState("{}");
    const [fieldList, setFieldList] = useState([]);

    const [pdfFile, setPdfFile] = useState(null);
    const [pdfFileName, setPdfFileName] = useState("");
    const [pdfS3Key, setPdfS3Key] = useState("");

    const [errors, setErrors] = useState({});

    const [isDatasetDropdownOpen, setIsDatasetDropdownOpen] = useState(false);
    const [isAgencyDropdownOpen, setIsAgencyDropdownOpen] = useState(false);
    const [datasetSearch, setDatasetSearch] = useState("");
    const [agencySearch, setAgencySearch] = useState("");
    const [showAllDatasetOptions, setShowAllDatasetOptions] = useState(false);
    const [showAllAgencyOptions, setShowAllAgencyOptions] = useState(false);
    const [viewType, setViewType] = useState("json");


    const pdfInputRef = useRef(null);

    useEffect(() => {
        fetchDatasets();
    }, [])

    useEffect(() => {
        if (datasetID) {
            fetchAgencieByDataset(datasetID);
        } else {
            setAgencies([]);
        }
    }, [datasetID]);


    const handleDatasetSearchChange = (event) => {
        const value = event.target.value;

        setDatasetSearch(value);
        setIsDatasetDropdownOpen(true);
        setShowAllDatasetOptions(false);

        if (datasetID) {
            setDatasetID("");
            setAgencyID("");
            setAgencySearch("");
            setAgencies([]);
            setOpraData(null);
            return;
        }

        if (!value) {
            setAgencyID("");
            setAgencySearch("");
            setAgencies([]);
            setOpraData(null);
        }

    };

    const handleDatasetKeyDown = (event) => {
        if (event.key === "Enter" && filteredDatasets.length > 0) {
            event.preventDefault();
            selectDataset(filteredDatasets[0]);
        }

        if (event.key === "Escape") {
            setIsDatasetDropdownOpen(false);
        }
    };


    const handleAgencySearchChange = (event) => {
        const value = event.target.value;
        setAgencySearch(value);
        setIsAgencyDropdownOpen(true);
        setShowAllAgencyOptions(false);

        if (agencyID) {
            setAgencyID("");
            setOpraData(null);
        }
    };

    const handleAgencyKeyDown = (event) => {
        if (event.key === "Enter" && filteredAgencyOptions.length > 0) {
            event.preventDefault();
            selectAgency(filteredAgencyOptions[0]);
        }

        if (event.key === "Escape") {
            setIsAgencyDropdownOpen(false);
        }
    };

    const selectDataset = (dataset) => {
        console.log("dataset", dataset);
        setDatasetID(dataset.datasetID);
        setDatasetName(dataset.datasetName);
        setDatasetSearch(getDatasetLabel(dataset));

        setAgencyID("");
        setAgencySearch("");
        setOpraData(null);

        setIsDatasetDropdownOpen(false);
        setShowAllDatasetOptions(false);
    };

    const selectAgency = (agency) => {
        setAgencyID(agency.agencyID);
        setAgencySearch(getAgencyLabel(agency));

        setOpraData(null);

        setIsAgencyDropdownOpen(false);
        setShowAllAgencyOptions(false);
    };


    const getDatasetLabel = (dataset) =>
        `${dataset.datasetName}`;

    const getAgencyLabel = (agency) =>
        `${agency.agencyID} - ${agency.agencyName}`;


    const selectedDataset = datasets.find((dataset) => dataset.datasetID === datasetID);
    const selectedDatasetLabel = selectedDataset ? getDatasetLabel(selectedDataset) : "";
    const datasetSearchText = datasetID && datasetSearch === selectedDatasetLabel
        ? ""
        : datasetSearch.trim().toLowerCase();

    const filteredDatasets = showAllDatasetOptions
        ? datasets
        : datasetSearchText
            ? datasets.filter((dataset) =>
                getDatasetLabel(dataset).toLowerCase().includes(datasetSearchText)
            )
            : datasets;

    const selectedAgency = agencies.find((agency) => agency.agencyID === agencyID);
    const selectedAgencyLabel = selectedAgency ? getAgencyLabel(selectedAgency) : "";
    const agencySearchText = agencyID && agencySearch === selectedAgencyLabel
        ? ""
        : agencySearch.trim().toLowerCase();

    const filteredAgencyOptions = showAllAgencyOptions
        ? agencies
        : agencySearchText
            ? agencies.filter((agency) =>
                getAgencyLabel(agency).toLowerCase().includes(agencySearchText)
            )
            : agencies;


    const fetchDatasets = async () => {
        try {
            const req = {};
            const response = await datasetDS.AP_Dataset_List_GET(req);

            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200 && Array.isArray(body.records)) {


                const accessLevel = localStorage.getItem('accessLevel');
                const isAdmin = accessLevel === '1';

                console.log("isAdmin", isAdmin);

                const allowedDatasets = JSON.parse(localStorage.getItem('winterSoldierDatasets') || '[]');

                const permittedDatasets = isAdmin
                    ? body.records
                    : body.records.filter(item => allowedDatasets.includes(item.datasetID)
                    );

                const requestDatasets = permittedDatasets.filter(item =>
                    item.entryType === "Request Based PDF Entry"
                );
                console.log("datasets", requestDatasets);
                setDatasets(requestDatasets);
            }
            else {
                showAlert(body?.message || "Failed to load Datasets.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
                insertLog(
                    `${userName} failed to fetch datasets`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    '',
                    'GET',
                    'AP_Dataset_List_GET',
                    'FAILED',
                    'Failed to load datasets'
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch datasets`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'GET',
                'AP_Dataset_List_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Something went wrong while fetching Datasets.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
        }
    };

    const fetchAgencieByDataset = async (datasetID) => {
        try {
            const req = { datasetID };
            const response = await requestSentDS.WS_Agency_ByDatasetID_GET(req);

            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && Array.isArray(body.records)) {
                setAgencies(body.records);

            } else {
                showAlert(body?.message || "Failed to load Agencies.", [
                    { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
                ]);
                insertLog(
                    `${userName} failed to fetch agencies for dataset ${datasetID}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    '',
                    'GET',
                    'WS_Agency_ByDatasetID_GET',
                    'FAILED',
                    `failed to fetch agencies for dataset ${datasetID}`
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch agencies for dataset ${datasetID}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'GET',
                'WS_Agency_ByDatasetID_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Something went wrong while fetching Agencies.", [
                { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
            ]);
        }
    };


    const handleAddressChange = (e) => {
        setOpraData((prev) => ({
            ...prev,
            agencyAddress: {
                ...prev.agencyAddress,
                address: e.target.value
            }
        }));
    };

    const handleUploadChange = (e) => {
        const file = e.target.files?.[0];

        if (!file) return;

        if (file.type !== "application/pdf") {
            showToast({ message: "Please select a PDF file" });
            e.target.value = "";
            return;
        }

        setPdfFile(file);
        setPdfFileName(file.name);
        setErrors((prev) => ({
            ...prev,
            pdf: ""
        }));
    };

    const handlePreviewPdf = () => {

        // Newly uploaded file
        if (pdfFile) {
            const fileUrl = URL.createObjectURL(pdfFile);
            window.open(fileUrl, "_blank");
            return;
        }

        // Existing S3 File
        if (pdfS3Key) {
            generatePresignedUrl(pdfS3Key);
        }
    };

    const convertJsonToList = () => {
        try {
            const parsed = JSON.parse(acroFields);

            const list = Object.entries(parsed).map(([key, value]) => ({
                key,
                value: value?.toString() || ""
            }));

            setFieldList(list);
        } catch (error) {
            console.error("Invalid JSON");
        }
    };

    const convertListToJson = () => {
        const jsonObject = {};

        fieldList.forEach((item) => {
            if (item.key.trim()) {
                jsonObject[item.key] = item.value;
            }
        });

        setAcroFields(JSON.stringify(jsonObject, null, 2));
    };

    const handleFieldChange = (index, field, value) => {
        const updated = [...fieldList];
        updated[index][field] = value;
        setFieldList(updated);
    };

    const handleViewChange = (type) => {

        if (type === "list") {
            convertJsonToList();
        }

        if (type === "json") {
            convertListToJson();
        }

        setViewType(type);
    };

    const handleDeleteField = (index) => {
        const updated = fieldList.filter((_, i) => i !== index);
        setFieldList(updated);
    };

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleRequestEmailChange = (index, value) => {
        const updated = [...requestEmails];
        updated[index] = value;
        setRequestEmails(updated);
        if (isValidEmail(value)) {
            setErrors((prev) => ({
                ...prev,
                requestEmails: ""
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                requestEmails: "Please enter a valid email address"
            }));
        }
    };

    const handleResponseEmailChange = (index, value) => {
        const updated = [...responseEmails];
        updated[index] = value;
        setResponseEmails(updated);
        if (isValidEmail(value)) {
            setErrors((prev) => ({
                ...prev,
                responseEmails: ""
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                responseEmails: "Please enter a valid email address"
            }));
        }
    };

    const addRequestEmail = () => {
        setRequestEmails([...requestEmails, ""]);
    };

    const addResponseEmail = () => {
        setResponseEmails([...responseEmails, ""]);
    };

    const removeRequestEmail = (index) => {
        showAlert(
            "Are you sure you want to delete this email?",
            [

                {
                    label: "No",
                    color: "#6c757d",
                    onClick: () => { }
                },
                {
                    label: "Yes",
                    color: "var(--buttonColor)",
                    onClick: () => {
                        const updated = requestEmails.filter(
                            (_, i) => i !== index
                        );
                        setRequestEmails(updated);
                    }
                }
            ]
        );
    };
    const removeResponseEmail = (index) => {
        showAlert(
            "Are you sure you want to delete this email?",
            [

                {
                    label: "No",
                    color: "#6c757d",
                    onClick: () => { }
                },
                {
                    label: "Yes",
                    color: "var(--buttonColor)",
                    onClick: () => {
                        const updated = responseEmails.filter(
                            (_, i) => i !== index
                        );
                        setResponseEmails(updated);
                    }
                },
            ]
        );
    };

    const handleAcroFieldsChange = (value) => {
        setAcroFields(value);

        if (!value.trim()) {
            setErrors((prev) => ({
                ...prev,
                acroFields: "Acro Fields are required"
            }));
            return;
        }
        try {
            const parsed = JSON.parse(value);
            if (typeof parsed === "object" && parsed !== null && Object.keys(parsed).length === 0) {
                setErrors((prev) => ({
                    ...prev,
                    acroFields: "Acro Fields are required"
                }));
            } else {
                setErrors((prev) => ({
                    ...prev,
                    acroFields: ""
                }));
            }
        } catch {
            setErrors((prev) => ({
                ...prev,
                acroFields: "Please enter valid JSON"
            }));
        }
    };

    const handleGet = async (e) => {
        e.preventDefault();

        setErrors({});

        if (!datasetID) {
            showToast({ message: "Please select a valid dataset from the dropdown" });
            return;
        }

        if (!agencyID) {
            showToast({ message: "Please select a valid agency from the dropdown" });
            return;
        }


        try {
            hud("Please Wait");

            const request = {
                datasetID: datasetID,
                agencyID: agencyID
            };

            const response = await requestOpraDS.WS_OPRA_Details_GET(request);
            const data = response.data;

            const body =
                typeof data.body === "string"
                    ? JSON.parse(data.body)
                    : data.body;

            if (data.statusCode === 200 && body.success) {
                console.log("OpraRecord", body.record);
                const record = body.record;

                setOpraData(record);
                setSmtpSettings({
                    fromEmail: record.smtpSettings?.fromEmail || "",
                    replyToEmail: record.smtpSettings?.replyToEmail || "",
                    subject: record.smtpSettings?.subject || ""
                });
                setRequestEmails(record.requestMethod?.emailSettings || []);
                setResponseEmails(record.responseMethod?.emailSettings || []);
                setTriggerEvents(record.TriggerEvents)

                setOffsetBegins(record.reqRange?.offsetBegins ?? "");
                setOffsetEnds(record.reqRange?.offsetEnds ?? "");
                setAcroFields(JSON.stringify(record.pdfForm?.acroFields || {}, null, 2));
                setViewType("json");
                const acroFieldsObj = record.pdfForm?.acroFields || {};

                setFieldList(
                    Object.keys(acroFieldsObj).length > 0
                        ? Object.entries(acroFieldsObj).map(([key, value]) => ({
                            key,
                            value: String(value ?? "")
                        }))
                        : [{ key: "", value: "" }]
                );
                setPdfFile(null);
                setPdfFileName("");
                if (pdfInputRef.current) pdfInputRef.current.value = "";

                setPdfS3Key(record.pdfForm?.s3Key || "");

            }
            else {
                setOpraData(null);

                showAlert(
                    body.message || "Record not found",
                    [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]
                );
                insertLog(
                    `${userName} failed to fetch OPRA details for agency '${agencyID}' and dataset '${datasetID}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    agencyID || '',
                    'GET',
                    'WS_OPRA_Details_GET',
                    'FAILED',
                    'API returned unsuccessful response'
                );
            }
        }
        catch (err) {
            console.error(err);
            setOpraData(null);
            showAlert(
                "Something went wrong. Please try again.",
                [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]
            );
            insertLog(
                `${userName} failed to fetch OPRA details for agency '${agencyID}' and dataset '${datasetID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                agencyID || '',
                'GET',
                'WS_OPRA_Details_GET',
                'FAILED',
                err.message
            );
        }
        finally {
            stopHudRotation();
        }
    };


    const normalizeBucketNamePart = (value) => (
        String(value)
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "-")
            .replace(/-+/g, "-")
            .replace(/^-+|-+$/g, "")
    );

    const uploadToS3 = async (file) => {
        const idToken = localStorage.getItem("idToken");

        const bucketName = `${normalizeBucketNamePart(datasetID)}-${normalizeBucketNamePart(datasetName)}-files-${process.env.REACT_APP_ALIAS}`;

        console.log("RequestBucket", bucketName);

        const s3 = new S3Client({
            region: process.env.REACT_APP_AWS_REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                logins: {
                    [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
                        idToken,
                },
            }),
        });

        const fileName = file.name;
        const key = `OnDemandRequestForms/${opraData?.agencyDisplayID}_${fileName}`;
        const command = new PutObjectCommand({
            Bucket: bucketName,
            Key: key,
            Body: await file.arrayBuffer(),
            ContentType: file.type,
        });

        await s3.send(command);
        return key;
    };


    const generatePresignedUrl = async (s3Key) => {
        if (!s3Key) {
            showAlert("No file available to preview.", [
                {
                    label: "OK",
                    color: "var(--buttonColor)",
                    onClick: () => { }
                }
            ]);
            return;
        } try {
            hud("Generating preview...");

            const idToken = localStorage.getItem("idToken");

            const bucketName = `${normalizeBucketNamePart(datasetID)}-${normalizeBucketNamePart(datasetName)}-files-${process.env.REACT_APP_ALIAS}`;

            const s3 = new S3Client({
                region: process.env.REACT_APP_AWS_REGION,
                credentials: fromCognitoIdentityPool({
                    clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                    identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                    logins: {
                        [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
                            idToken,
                    },
                }),
            });

            const { getSignedUrl } = await import("@aws-sdk/s3-request-presigner");
            const { GetObjectCommand } = await import("@aws-sdk/client-s3");

            const command = new GetObjectCommand({
                Bucket: bucketName,
                Key: s3Key,
            });

            const signedUrl = await getSignedUrl(s3, command, { expiresIn: 300 }); // 5 min
            window.open(signedUrl, "_blank");

        } catch (err) {
            console.error("Presigned URL error:", err);
            showAlert("Failed to generate preview. Please try again.", [
                { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
            ]);
        } finally {
            stopHudRotation();
        }
    };

    const validateRequestOpra = () => {
        const newErrors = {};


        if (!smtpSettings?.subject?.trim()) {
            newErrors.smtpSubject = "Subject is required";
        }
        if (!requestEmails.length || requestEmails.some(email => !email?.trim())) {
            newErrors.requestEmails = "At least one Request Email is required";
        }
        else if (
            requestEmails.some(email => !isValidEmail(email))
        ) {
            newErrors.requestEmails = "Please enter valid request email(s)";
        }

        // if (!responseEmails.length || responseEmails.some(email => !email?.trim())) {
        //     newErrors.responseEmails = "At least one Response Email is required";
        // }
        // else if (
        //     responseEmails.some(email => !isValidEmail(email))
        // ) {
        //     newErrors.responseEmails = "Please enter valid response email(s)";
        // }

        if (!pdfS3Key && !pdfFile) {
            newErrors.pdf = "PDF file is required";
        }

        if (offsetBegins === "" || offsetBegins === null) {
            newErrors.offsetBegins = "Offset Begins is required";
        }
        else if (Number(offsetBegins) > 0) {
            newErrors.offsetBegins = "Offset Ends must be 0 or a negative number";
        }

        if (offsetEnds === "" || offsetEnds === null) {
            newErrors.offsetEnds = "Offset Ends is required";
        }
        else if (Number(offsetEnds) > 0) {
            newErrors.offsetEnds = "Offset Ends must be 0 or a negative number";
        }

        if (!triggerEvents?.length || triggerEvents[0]?.waitDays === "" || triggerEvents[0]?.waitDays == null) {
            newErrors.waitDays = "Wait Days is required";
        }
        const invalidTrigger = triggerEvents.some((t) => t.waitDays === "" || t.waitDays === null || Number(t.waitDays) <= 0
        );

        if (!triggerEvents.length || invalidTrigger) {
            newErrors.waitDays = "Wait Days must be greater than 0";
        }


        if (viewType === "json") {
            try {
                const parsed = JSON.parse(acroFields);

                if (typeof parsed === "object" && parsed !== null && Object.keys(parsed).length === 0) {
                    newErrors.acroFields = "Acro Fields are required";
                }
            } catch {
                newErrors.acroFields = "Please enter valid JSON";
            }
        } else {
            const validRows = fieldList.filter(
                item => item.key?.trim() && item.value?.trim()
            );

            if (validRows.length === 0) {
                newErrors.acroFields = "At least one field is required";
            }
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleConfirmationOPRA = () => {
        if (opraData?.isActive === false) {
            showAlert(`Agency ${opraData?.agencyName} is inactive.`, [
                {
                    label: "Cancel",
                    color: "var(--buttonColor)",
                    onClick: () => { }
                },
                {
                    label: "Send Anyway",
                    color: "var(--buttonColor)",
                    onClick: () => {handleSendOpra()}
                }
            ]);
        }else{
            handleSendOpra();
        }
    }

    const handleSendOpra = async () => {
        if (!validateRequestOpra()) {
            return;
        }
        try {

            hud("Please Wait");

            let finalS3Key = pdfS3Key;
            let finalFileName =
                opraData?.pdfForm?.fileName ||
                (pdfS3Key || opraData?.pdfForm?.s3Key)?.split("/").pop() ||
                "";

            if (pdfFile) {
                finalS3Key = await uploadToS3(pdfFile);
                finalFileName = pdfFile.name;
                setPdfS3Key(finalS3Key);
            }

            const request = {
                loggedUser: useremail,
                datasetID: opraData?.datasetID,
                datasetName: opraData?.datasetName,
                agencyID: opraData?.agencyID,
                agencyName: opraData?.agencyName,
                agencyPhoneNumbers: opraData?.agencyPhoneNumbers,
                agencyAddress: opraData?.agencyAddress,
                phoneNumber: opraData?.phoneNumber,
                agencyDisplayName: opraData?.agencyDisplayName,
                isActive: opraData?.isActive,
                pdfForm: {
                    s3Key: finalS3Key,
                    fileName: finalFileName,
                    acroFields: acroFields ? JSON.parse(acroFields) : {}
                },

                smtpSettings: {
                    ...smtpSettings,
                    subject: smtpSettings.subject.trim()
                },

                requestMethod: {
                    requestType: "Email",
                    emailSettings: requestEmails
                },

                responseMethod: {
                    responseType: "Email",
                    emailSettings: responseEmails
                },

                TriggerEvents: triggerEvents.map(event => ({
                    waitDays: Number(event.waitDays),
                    action: event.action
                })),

                reqRange: {
                    offsetBegins: Number(offsetBegins),
                    offsetEnds: Number(offsetEnds)
                }
            };
            const response = await requestOpraDS.WS_OPRA_Send_Mail(request);
            const data = response.data;

            const status = data?.statusCode;

            if (status === 200) {
                showAlert(data?.body || "OPRA sent successfully", [
                    {
                        label: "OK",
                        color: "var(--buttonColor)",
                        onClick: async () => {
                            setOpraData(null);
                            setAgencyID("");
                            setAgencySearch("");
                            setAcroFields("");
                            setFieldList([{ key: "", value: "" }]);
                            setViewType("json");
                        }
                    }
                ]);
                insertLog(
                    `${userName} sent OPRA request email for Agency ID: ${request.agencyID}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    request.agencyID || '',
                    'INSERT',
                    'WS_OPRA_Send_Mail',
                    'SUCCESS',
                    ''
                );
                return;
            }

            else {
                showAlert(data?.body || "Failed to send OPRA", [
                    {
                        label: "OK",
                        color: "var(--buttonColor)",
                        onClick: () => { }
                    }
                ]);
                insertLog(
                    `${userName} failed to send OPRA request email for Agency ID: ${opraData?.agencyID}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    opraData?.agencyID || '',
                    'INSERT',
                    'WS_OPRA_Send_Mail',
                    'FAILED',
                    'Failed to send OPRA request'
                );
            }

        } catch (err) {
            console.error(err);

            showAlert("Failed to send OPRA", [
                {
                    label: "OK",
                    color: "var(--buttonColor)",
                    onClick: () => { }
                }
            ]);
            insertLog(
                `${userName} failed to send OPRA request email for Agency ID: ${opraData?.agencyID}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                opraData?.agencyID || '',
                'INSERT',
                'WS_OPRA_Send_Mail',
                'FAILED',
                'Failed to send OPRA request'
            );

        } finally {
            stopHudRotation();
        }
    };

    const formatDate = (date, separator = "/") => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${mm}${separator}${dd}${separator}${yyyy}`;
    }



    const fillPdfWithAcroFields = async (pdfBytes, fieldsJson) => {
        const pdfDoc = await PDFDocument.load(pdfBytes);
        const form = pdfDoc.getForm();
        const fields = form.getFields();

        console.log(
            "PDF field keys (from uploaded PDF):",
            fields.map((f) => f.getName())
        );

        const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
        form.updateFieldAppearances(font);

        const setFieldText = (fieldName, value) => {
            const field = form.getFieldMaybe(fieldName);
            if (!field) {
                console.log(`Field NOT found: ${fieldName}`);
                return;
            }
            if (field.setText) {
                try {
                    field.setText(value ?? "");
                    if (opraData?.agencyID === "800") {
                        field.setFontSize(11);
                    } else {
                        field.setFontSize(12);
                    }
                    field.updateAppearances(font);
                } catch (err) {
                    console.warn(`Could not set field "${fieldName}":`, err.message);
                }
            }
        };

        const placeImageOnField = async (field, imageBuffer, fileName) => {
            if (!field) throw new Error("Field is required");

            const widgets = field.acroField.getWidgets();
            if (!widgets || widgets.length === 0) return false;

            const widget = widgets[0];
            const widgetRef = widget.ref;
            const rect = widget.getRectangle();
            if (!rect) return false;

            let image;
            if (fileName.toLowerCase().endsWith(".jpg") || fileName.toLowerCase().endsWith(".jpeg")) {
                image = await pdfDoc.embedJpg(imageBuffer);
            } else {
                image = await pdfDoc.embedPng(imageBuffer);
            }

            const pages = pdfDoc.getPages();
            let page = null;
            for (const p of pages) {
                const annots = p.node.Annots && p.node.Annots();
                if (!annots) continue;

                const size = typeof annots.size === "function" ? annots.size() : (annots.length || 0);
                for (let i = 0; i < size; i++) {
                    const aRef = typeof annots.get === "function" ? annots.get(i) : annots[i];
                    if (
                        aRef === widgetRef ||
                        (aRef?.toString && widgetRef?.toString && aRef.toString() === widgetRef.toString())
                    ) {
                        page = p;
                        break;
                    }
                }
                if (page) break;
            }

            if (!page) page = pages[0];

            page.drawImage(image, {
                x: rect.x,
                y: rect.y,
                width: rect.width,
                height: rect.height,
            });

            return true;
        };

        for (let [fieldName, fieldValue] of Object.entries(fieldsJson)) {

            if (fieldName === "vinsafety_signature") {
                const value = fieldValue;
                if (value) {
                    const field = form.getFieldMaybe(fieldName);
                    if (!field) {
                        continue;
                    }
                    const signatureBuffer = await fetchFileBytesFromS3(value);
                    await placeImageOnField(field, signatureBuffer, value);
                }
                continue;
            }

            if (fieldName === "vinsafety_sentdate") {
                fieldValue = formatDate(new Date());
            }
            else if (
                fieldName === "vinsafety_comment" ||
                fieldName === "vinsafety_startdate" ||
                fieldName === "vinsafety_enddate"
            ) {
                const beginOffset = Number(offsetBegins) || 0;
                const endOffset = Number(offsetEnds) || 0;

                const now = new Date();

                const beginDateObj = new Date(now);
                beginDateObj.setDate(now.getDate() + beginOffset);

                const endDateObj = new Date(now);
                endDateObj.setDate(now.getDate() + endOffset);

                const beginDate = formatDate(beginDateObj);
                const endDate = formatDate(endDateObj);

                if (fieldName === "vinsafety_startdate") {
                    fieldValue = beginDate;
                } else if (fieldName === "vinsafety_enddate") {
                    fieldValue = endDate;
                } else {
                    fieldValue = fieldValue
                        .replace("[offsetBegins]", beginDate)
                        .replace("[offsetEnds]", endDate)
                        .replace("[breakline]", "\n");
                }
            }
            else if ([
                "vinsafety_delivery_pickup",
                "vinsafety_delivery_snailmail",
                "vinsafety_delivery_fax",
                "vinsafety_delivery_email"
            ].includes(fieldName)) {

                const typeMap = {
                    vinsafety_delivery_pickup: "Pick Up",
                    vinsafety_delivery_snailmail: "Snail Mail",
                    vinsafety_delivery_fax: "Fax",
                    vinsafety_delivery_email: "Email"
                };

                const currentResponseType = opraData?.responseMethod?.responseType;
                fieldValue = currentResponseType === typeMap[fieldName] ? "X" : "";
            }

            setFieldText(fieldName, fieldValue);
        }
        const formatVINDate = (date) => {
            return new Date(date).toISOString().split("T")[0];
        };
        const vin = `VIN-${datasetID}-${opraData.agencyID}-${formatVINDate(new Date())}-XXX`

        setFieldText("vinsafety_requestid", vin);
        setFieldText("Header_Township", opraData?.agencyDisplayName || "");

        if (opraData?.agencyPhoneNumbers) {
            const primaryPhone = opraData.agencyPhoneNumbers.find((x) => x.isPrimary === true);
            setFieldText("Header_Phone", primaryPhone?.number ? `Ph: ${primaryPhone.number}` : "");
        }

        if (opraData?.agencyAddress) {
            setFieldText("Header_Address", opraData.agencyAddress.address || "");
        }

        return await pdfDoc.save();
    };

    const fetchFileBytesFromS3 = async (s3Key) => {
        const idToken = localStorage.getItem("idToken");
        const bucketName = `${normalizeBucketNamePart(datasetID)}-${normalizeBucketNamePart(datasetName)}-files-${process.env.REACT_APP_ALIAS}`;

        const s3 = new S3Client({
            region: process.env.REACT_APP_AWS_REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                logins: {
                    [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
                        idToken,
                },
            }),
        });

        const { GetObjectCommand } = await import("@aws-sdk/client-s3");
        const command = new GetObjectCommand({ Bucket: bucketName, Key: s3Key });
        const response = await s3.send(command);

        return await response.Body.transformToByteArray();
    };

    const handlePreviewFilledPdf = async () => {

        if (!pdfFile && !pdfS3Key) {
            showAlert("Please upload a PDF file before previewing.", [
                { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
            ]);
            return;
        }
        try {
            hud("Please Wait...");

            let fieldsJson;
            if (viewType === "json") {
                fieldsJson = acroFields ? JSON.parse(acroFields) : {};
            } else {
                fieldsJson = {};
                fieldList.forEach((item) => {
                    if (item.key.trim()) fieldsJson[item.key] = item.value;
                });
            }

            // Object.keys(fieldsJson).forEach((key) => {
            //     if (typeof fieldsJson[key] === "string") {
            //         fieldsJson[key] = fieldsJson[key]
            //             .replace("[offsetBegins]", offsetBegins ?? "")
            //             .replace("[offsetEnds]", offsetEnds ?? "");
            //     }
            // });

            let pdfBytes;
            if (pdfFile) {
                pdfBytes = await pdfFile.arrayBuffer();
            } else if (pdfS3Key) {
                pdfBytes = await fetchFileBytesFromS3(pdfS3Key)
            } else {
                showToast({ message: "Please upload a PDF first" });
                return;
            }

            const filledPdfBytes = await fillPdfWithAcroFields(pdfBytes, fieldsJson);

            const blob = new Blob([filledPdfBytes], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank");

        } catch (err) {
            console.error("Preview generation error:", err);
            if (err.message?.includes("JSON")) {
                showToast({ message: "Please enter valid JSON before previewing" });
            } else {
                showAlert("Failed to generate preview. Please try again.", [
                    { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
                ]);
            }
        } finally {
            stopHudRotation();
        }
    };




    return (

        <div className="main-content">
            <div className="custom-header-opra">
                <span className="title">Request OPRA</span>
            </div>
            <div className="mt-3">
                <div className="content-opra-headers">
                    <form className="opra-filter-panel" onSubmit={handleGet}>
                        <div className="opra-control-group">
                            <label htmlFor="opra-dataset">Dataset</label>
                            <div
                                className="opra-search-select"
                                onBlur={(event) => {
                                    if (!event.currentTarget.contains(event.relatedTarget)) {
                                        setIsDatasetDropdownOpen(false);
                                    }
                                }}
                            >
                                <input
                                    id="opra-dataset"
                                    type="text"
                                    value={datasetSearch}
                                    onChange={handleDatasetSearchChange}
                                    onFocus={() => {
                                        setIsDatasetDropdownOpen(true);
                                        setIsAgencyDropdownOpen(false);
                                        setShowAllDatasetOptions(false);
                                    }}
                                    onKeyDown={handleDatasetKeyDown}
                                    placeholder="Select Dataset"
                                    autoComplete="off"
                                />

                                <button
                                    className="opra-search-select-toggle"
                                    type="button"
                                    onClick={() => {
                                        setIsAgencyDropdownOpen(false);
                                        if (!showAllDatasetOptions) {
                                            setShowAllDatasetOptions(true);
                                            setIsDatasetDropdownOpen(true);
                                            return;
                                        }
                                        setShowAllDatasetOptions(false);
                                        setIsDatasetDropdownOpen(false);
                                    }}
                                    aria-label="Toggle dataset options"
                                >
                                    <FiChevronDown />
                                </button>

                                {isDatasetDropdownOpen && (
                                    <div className="opra-search-select-menu">
                                        {filteredDatasets.length > 0 ? (
                                            filteredDatasets.map((dataset, index) => (
                                                <button
                                                    key={`${dataset.datasetID || getDatasetLabel(dataset)}-${index}`}
                                                    type="button"
                                                    className={`opra-search-select-option ${datasetID === dataset.datasetID ? "selected" : ""
                                                        }`}
                                                    onMouseDown={(event) => event.preventDefault()}
                                                    onClick={() => selectDataset(dataset)}
                                                >
                                                    {getDatasetLabel(dataset)}
                                                </button>
                                            ))
                                        ) : (
                                            <div className="opra-search-select-empty">
                                                No datasets found
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                        </div>

                        <div className="opra-control-group">
                            <label htmlFor="opra-agency">Agency</label>

                            <div
                                className={`opra-search-select ${!datasetID ? "disabled" : ""}`}
                                onBlur={(event) => {
                                    if (!event.currentTarget.contains(event.relatedTarget)) {
                                        setIsAgencyDropdownOpen(false);
                                    }
                                }}
                            >
                                <input
                                    id="opra-agency"
                                    type="text"
                                    value={agencySearch}
                                    onChange={handleAgencySearchChange}
                                    onFocus={() => {
                                        if (datasetID) {
                                            setIsDatasetDropdownOpen(false);
                                            setIsAgencyDropdownOpen(true);
                                            setShowAllAgencyOptions(false);
                                        }
                                    }}
                                    onKeyDown={handleAgencyKeyDown}
                                    placeholder="Select Agency"
                                    autoComplete="off"
                                    disabled={!datasetID}
                                />

                                <button
                                    className="opra-search-select-toggle"
                                    type="button"
                                    onClick={() => {
                                        if (datasetID) {
                                            setIsDatasetDropdownOpen(false);
                                            if (!showAllAgencyOptions) {
                                                setShowAllAgencyOptions(true);
                                                setIsAgencyDropdownOpen(true);
                                                return;
                                            }
                                            setShowAllAgencyOptions(false);
                                            setIsAgencyDropdownOpen(false);
                                        }
                                    }}
                                    aria-label="Toggle agency options"
                                    disabled={!datasetID}
                                >
                                    <FiChevronDown />
                                </button>

                                {isAgencyDropdownOpen && (
                                    <div className="opra-search-select-menu">
                                        {filteredAgencyOptions.length > 0 ? (
                                            filteredAgencyOptions.map((agency, index) => (
                                                <button
                                                    key={`${agency.agencyID || getAgencyLabel(agency)}-${index}`}
                                                    type="button"
                                                    className={`opra-search-select-option ${agencyID === agency.agencyID ? "selected" : ""
                                                        }`}
                                                    onMouseDown={(event) => event.preventDefault()}
                                                    onClick={() => selectAgency(agency)}
                                                >
                                                    {getAgencyLabel(agency)}
                                                </button>
                                            ))
                                        ) : (
                                            <div className="opra-search-select-empty">
                                                No agencies found
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        <button className="opra-submit-btn" type="submit">
                            <FiSearch /> Search
                        </button>
                    </form>


                </div>

                <div className="content-opra mt-3">
                    {!opraData ? (
                        <div className="opra-empty-state">
                            Please select Dataset and Agency to view details
                        </div>
                    ) : (

                        <div className="opra-details-card">

                            {/* Agency Information */}
                            <div className="opra-section-card">
                                <div className="opra-section-title">
                                    Agency Information
                                </div>

                                <div className="opra-agency-grid">

                                    <div>
                                        <label className="opra-small-label">Agency ID</label>
                                        <input
                                            type="text"
                                            className="form-control opra-readonly-input"
                                            value={opraData.agencyID || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">Dataset ID</label>
                                        <input
                                            type="text"
                                            className="form-control opra-readonly-input"
                                            value={opraData.datasetID || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">Agency Name</label>
                                        <input
                                            type="text"
                                            className="form-control opra-readonly-input"
                                            value={opraData.agencyName || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">Agency Display ID</label>
                                        <input
                                            type="text"
                                            className="form-control opra-readonly-input"
                                            value={opraData.agencyDisplayID || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">Agency Display Name</label>
                                        <input
                                            type="text"
                                            className="form-control opra-readonly-input"
                                            value={opraData.agencyDisplayName || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">Agency Department</label>
                                        <input
                                            type="text"
                                            className="form-control opra-readonly-input"
                                            value={opraData.agencyDepartment || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">Contact Person</label>
                                        <input
                                            type="text"
                                            className="form-control opra-readonly-input"
                                            value={opraData.agencyContactPerson || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">Handled By</label>
                                        <input
                                            type="text"
                                            className="form-control opra-readonly-input"
                                            value={opraData.Handledby || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">Handled By User</label>
                                        <input
                                            type="text"
                                            className="form-control opra-readonly-input"
                                            value={opraData.handledByUser || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">Handled By User Email</label>
                                        <input
                                            type="text"
                                            className="form-control opra-readonly-input"
                                            value={opraData.handledByUserEmail || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">SMTP Settings - Subject<span className="required-opra"><LuAsterisk /></span></label>
                                        <input
                                            type="text"
                                            className={`form-control opra-edit-input ${errors.smtpSubject ? "opra-input-error" : ""}`}
                                            value={smtpSettings.subject}
                                            onChange={(e) => {
                                                setSmtpSettings(prev => ({
                                                    ...prev,
                                                    subject: e.target.value
                                                }));

                                                setErrors(prev => ({
                                                    ...prev,
                                                    smtpSubject: ""
                                                }));
                                            }}
                                        />
                                        {errors.smtpSubject && (
                                            <div className="opra-error">{errors.smtpSubject}</div>
                                        )}
                                    </div>

                                    <div>
                                        <label className="opra-small-label">Address</label>
                                        <input
                                            type="text"
                                            className="opra-edit-input"
                                            value={opraData?.agencyAddress?.address || ""}
                                            onChange={handleAddressChange}
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">City</label>
                                        <input
                                            type="text"
                                            className="form-control opra-edit-input"
                                            value={opraData?.agencyAddress?.city || ""}

                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">State</label>
                                        <input
                                            type="text"
                                            className="form-control opra-edit-input"
                                            value={opraData?.agencyAddress?.state || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div>
                                        <label className="opra-small-label">Zip</label>
                                        <input
                                            type="text"
                                            className="form-control opra-edit-input"
                                            value={opraData?.agencyAddress?.zip || ""}
                                            readOnly
                                        />
                                    </div>

                                </div>

                            </div>

                            {/* File Details */}
                            <div className="opra-section-card">

                                <label className="opra-section-title">
                                    Report Request Form File<span className="required-opra"><LuAsterisk /></span>
                                </label>

                                <div className="opra-file-row">
                                    <input
                                        ref={pdfInputRef}
                                        type="file"
                                        accept=".pdf"
                                        onChange={handleUploadChange}
                                        className={`form-control opra-file-input ${errors.pdf ? "opra-input-error" : ""}`} />

                                    {(pdfFileName || pdfS3Key) && (
                                        <span className="opra-file-name"
                                            title={
                                                pdfFileName ||
                                                (pdfS3Key ? pdfS3Key.split("/").pop() : "")
                                            }>
                                            {pdfFileName ||
                                                (pdfS3Key ? pdfS3Key.split("/").pop() : "")}
                                        </span>
                                    )}

                                    {(pdfS3Key || pdfFile) && (
                                        <span
                                            type="button"
                                            className="opra-preview-btn"
                                            onClick={handlePreviewPdf}
                                        >
                                            <FaEye />
                                        </span>
                                    )}
                                </div>
                                {errors.pdf && (
                                    <div className="opra-error">{errors.pdf}</div>
                                )}

                                <div className="mt-3">
                                    <div className="opra-textarea-header">
                                        <label className="opra-section-label">
                                            AcroFields JSON
                                            <span className="required-opra">
                                                <LuAsterisk />
                                            </span>
                                        </label>

                                        <div className="opra-actions">
                                            <button
                                                type="button"
                                                className="prev-btn"
                                                onClick={handlePreviewFilledPdf}
                                            >
                                                Preview
                                            </button>
                                            <div className="opra-tab-container">

                                                <button
                                                    type="button"
                                                    className={`tab-btn-opra ${viewType === "json" ? "active" : ""}`}
                                                    onClick={() => handleViewChange("json")}

                                                >
                                                    JSON
                                                </button>

                                                <button
                                                    type="button"
                                                    className={`tab-btn-opra ${viewType === "list" ? "active" : ""}`}
                                                    onClick={() => handleViewChange("list")}

                                                >
                                                    LIST
                                                </button>
                                            </div>
                                        </div>

                                    </div>

                                    {viewType === "json" ? (

                                        <textarea
                                            className={`form-control opra-edit-textarea ${errors.acroFields ? "opra-input-error" : ""}`}
                                            rows={7}
                                            value={acroFields}
                                            onChange={(e) => handleAcroFieldsChange(e.target.value)}
                                        />
                                    ) : (

                                        <div className="opra-list-container">

                                            <div className="opra-add-field-container">
                                                <span
                                                    className="opra-add-field-link"
                                                    onClick={() =>
                                                        setFieldList([
                                                            ...fieldList,
                                                            { key: "", value: "" }
                                                        ])
                                                    }
                                                >
                                                    + Add Field
                                                </span>
                                            </div>
                                            <table className="opra-list-table">
                                                <colgroup>
                                                    <col style={{ width: "45%" }} />
                                                    <col style={{ width: "45%" }} />
                                                    <col style={{ width: "10%" }} />
                                                </colgroup>

                                                <thead>
                                                    <tr>
                                                        <th>Field Name (Key)</th>
                                                        <th>Field Value</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {fieldList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control opra-list-input"
                                                                    placeholder="Enter field name"
                                                                    value={item.key}
                                                                    onChange={(e) =>
                                                                        handleFieldChange(index, "key", e.target.value)
                                                                    }
                                                                />
                                                            </td>

                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control opra-list-input"
                                                                    placeholder="Enter value"
                                                                    value={item.value}
                                                                    onChange={(e) =>
                                                                        handleFieldChange(index, "value", e.target.value)
                                                                    }
                                                                />
                                                            </td>

                                                            <td className="text-center">
                                                                <RiDeleteBin3Fill
                                                                    size={16}
                                                                    style={{
                                                                        color: "#dc3545",
                                                                        cursor: "pointer"
                                                                    }}
                                                                    onClick={() => handleDeleteField(index)}

                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                        </div>
                                    )}
                                    {errors.acroFields && (
                                        <div className="opra-error">
                                            {errors.acroFields}
                                        </div>
                                    )}
                                </div>

                            </div>


                            {/* Request & Response */}

                            <div className="opra-section-card">
                                <div className="opra-section-title">
                                    Emails
                                </div>
                                <div className="opra-details-grid">

                                    {/* Request Emails */}
                                    <div className="opra-details-column">
                                        <label className="opra-section-label">
                                            Request Emails<span className="required-opra"><LuAsterisk /></span>
                                        </label>

                                        {requestEmails.map((email, index) => (
                                            <div key={index} className="opra-email-row">

                                                <input
                                                    type="email"
                                                    className="form-control opra-edit-input"
                                                    value={email}
                                                    placeholder="Enter Email"
                                                    onChange={(e) =>
                                                        handleRequestEmailChange(index, e.target.value)
                                                    }
                                                />
                                                {requestEmails.length > 1 && (
                                                    <span
                                                        type="button"
                                                        className="opra-delete-btn"
                                                        onClick={() => removeRequestEmail(index)}
                                                        title="Delete Email"
                                                    >
                                                        <RiDeleteBin3Fill
                                                            size={16}
                                                            style={{ color: "#dc3545", cursor: "pointer" }} />
                                                    </span>
                                                )}
                                            </div>

                                        ))}
                                        {errors.requestEmails && (
                                            <div className="opra-error">{errors.requestEmails}</div>
                                        )}
                                        <button
                                            type="button"
                                            className="opra-add-btn"
                                            onClick={addRequestEmail}
                                        >
                                            <IoAdd size={16} style={{ marginTop: "-4px", color: "white" }} />
                                            Add Email
                                        </button>

                                    </div>
                                    {/* Response Emails */}
                                    {/* <div className="opra-details-column">
                                        <label className="opra-section-label">
                                            Response Emails<span className="required-opra"><LuAsterisk /></span>
                                        </label>

                                        {responseEmails.map((email, index) => (
                                            <div key={index} className="opra-email-row">

                                                <input
                                                    type="email"
                                                    className="form-control opra-edit-input"
                                                    value={email}
                                                    placeholder="Enter Email"
                                                    onChange={(e) =>
                                                        handleResponseEmailChange(index, e.target.value)
                                                    }
                                                />

                                                {responseEmails.length > 1 && (
                                                    <span
                                                        type="button"
                                                        className="opra-delete-btn"
                                                        onClick={() => removeResponseEmail(index)}
                                                        title="Delete Email"
                                                    >
                                                        <RiDeleteBin3Fill
                                                            size={16}
                                                            style={{ color: "#dc3545", cursor: "pointer" }} />
                                                    </span>
                                                )}
                                            </div>
                                        ))}
                                        {errors.responseEmails && (
                                            <div className="opra-error">{errors.responseEmails}</div>
                                        )}

                                        <button
                                            type="button"
                                            className="opra-add-btn"
                                            onClick={addResponseEmail}
                                        >
                                            <IoAdd size={16} style={{ marginTop: "-4px", color: "white" }} />
                                            Add Email
                                        </button>
                                    </div> */}
                                </div>
                            </div>


                            <div className="opra-section-card">
                                <div className="opra-section-title">
                                    Trigger Events
                                </div>

                                {triggerEvents.map((event, index) => (
                                    <div key={index} className="opra-date-grid">

                                        <div>
                                            <label className="opra-small-label">
                                                Wait Days
                                                <span className="required-opra">
                                                    <LuAsterisk />
                                                </span>
                                            </label>

                                            <input
                                                type="number"
                                                className={`form-control opra-edit-input ${errors.waitDays ? "opra-input-error" : ""}`}
                                                value={event.waitDays || ""}
                                                onWheel={(e) => e.currentTarget.blur()}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value === "") {
                                                        const updated = [...triggerEvents];
                                                        updated[index].waitDays = "";
                                                        setTriggerEvents(updated);

                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            waitDays: ""
                                                        }));
                                                        return;
                                                    }
                                                    if (Number(value) <= 0) {
                                                        return;
                                                    }

                                                    const updated = [...triggerEvents];
                                                    updated[index].waitDays = value;
                                                    setTriggerEvents(updated);

                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        waitDays: ""
                                                    }));
                                                }}
                                            />
                                            {errors.waitDays && (
                                                <div className="opra-error">{errors.waitDays}</div>
                                            )}
                                        </div>

                                    </div>
                                ))}
                            </div>
                            {/* Request Date Range */}
                            <div className="opra-section-card">
                                <div className="opra-section-title">
                                    Request Date Range
                                </div>

                                <div className="opra-date-grid">

                                    <div>
                                        <label className="opra-small-label">
                                            Offset Begins<span className="required-opra"><LuAsterisk /></span>
                                        </label>

                                        <input
                                            type="number"
                                            className={`form-control opra-file-input ${errors.offsetBegins ? "opra-input-error" : ""}`}
                                            value={offsetBegins}
                                            onWheel={(e) => e.currentTarget.blur()}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                if (value === "") {
                                                    setOffsetBegins("");
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        offsetBegins: ""
                                                    }));
                                                    return;
                                                }
                                                if (Number(value) > 0) {
                                                    return;
                                                }
                                                setOffsetBegins(value);

                                                setErrors((prev) => ({
                                                    ...prev,
                                                    offsetBegins: ""
                                                }));
                                            }}
                                        />
                                        {errors.offsetBegins && (
                                            <div className="opra-error">{errors.offsetBegins}</div>
                                        )}
                                    </div>

                                    <div>
                                        <label className="opra-small-label">
                                            Offset Ends<span className="required-opra"><LuAsterisk /></span>
                                        </label>
                                        <input
                                            type="number"
                                            className={`form-control opra-file-input ${errors.offsetEnds ? "opra-input-error" : ""}`}
                                            value={offsetEnds}
                                            onWheel={(e) => e.currentTarget.blur()}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                if (value === "") {
                                                    setOffsetEnds("");
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        offsetEnds: ""
                                                    }));
                                                    return;
                                                }

                                                // Block positive numbers
                                                if (Number(value) > 0) {
                                                    return;
                                                }

                                                setOffsetEnds(value);

                                                setErrors((prev) => ({
                                                    ...prev,
                                                    offsetEnds: ""
                                                }));
                                            }}
                                        />
                                        {errors.offsetEnds && (
                                            <div className="opra-error">{errors.offsetEnds}</div>
                                        )}
                                    </div>

                                </div>
                            </div>

                            {/* Send OPRA Button */}
                            <div className="opra-action-row">
                                <button
                                    type="button"
                                    className="opra-btn-send"
                                    onClick={handleConfirmationOPRA}
                                >
                                    Send OPRA
                                </button>
                            </div>

                        </div>
                    )}
                </div>
            </div>
        </div>



    )
}

export default RequestOpra;
